module.exports = __webpack_public_path__ + "35d238195b689fc46b3b247a832b4e01.svg";